import React, { ComponentProps, FunctionComponent } from 'react';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './CardStandard.module.css';

export type CardStandardProps = ComponentProps<'div'>;

export const CardStandard: FunctionComponent<CardStandardProps> = React.memo(
  (props) => {
    const { className, children, ...remainingProps } = prepareProps({ props });
    return (
      <div
        {...remainingProps}
        className={classes(className, styles.card)}
      >
        {children}
      </div>
    );
  }
);
